(function () {
  function alignButtons() {
    document.querySelectorAll('.card-product__tile').forEach(function (tile) {
      var btn = tile.querySelector('.add-to-cart-new');
      var tag = tile.querySelector('.card-product__tag');
      if (!btn || !tag) return;

      var tileRect = tile.getBoundingClientRect();
      var tagRect  = tag.getBoundingClientRect();

      // Calcola il bottom per allineamento con il collection tag
      var bottomPx = Math.max(0, tileRect.bottom - tagRect.top);

      // Usa il tuo offset personalizzato (sposta leggermente verso il basso)
      var offset = -26; // ⬅️ qui imposti il tuo valore
      btn.style.setProperty('bottom', (bottomPx + offset) + 'px', 'important');
    });
  }

  // Osserva variazioni nella card (accordion, resize, ecc.)
  function observeCardChanges(tile) {
    var observer = new MutationObserver(alignButtons);
    observer.observe(tile, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  // Esegui subito e su eventi dinamici
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.card-product__tile').forEach(function(tile){
      observeCardChanges(tile);
    });
    alignButtons();
  });
  window.addEventListener('resize', alignButtons);
  window.addEventListener('load', alignButtons);
})();